<template>
  <div class="container" :style="{backgroundImage: `url(${require('../../assets/image/bg_container.jpg')})`}">
    <div class="page-header" :style="{backgroundImage: `url(${require('../../assets/image/bg_header.png')})`}">
      <header-time ref="headerTime"></header-time>
      <header-about></header-about>
      <header-weather ref="headerWeather"></header-weather>
    </div>

    <div class="page-main">

      <div class="login-wrapper">
        <div class="login-box">
          <div class="login-title">欢迎登录系统</div>

          <div class="login-row">
            <img class="row-icon" src="../../assets/image/icon_account.png" />
            <input class="row-input" v-model="username" placeholder="请输入用户名"/>>
          </div>

          <div class="login-row">
            <img class="row-icon" src="../../assets/image/icon_password.png" />
            <input type="password" class="row-input" v-model="password" placeholder="请输入密码"/>
          </div>

          <div class="login-row">
            <img class="row-icon" src="../../assets/image/icon_code.png" />
            <input class="row-input" v-model="captcha" placeholder="请输入验证码" />
            <img @click="getCodeImg" class="row-code" :src="'data:image/jpg;base64,' + captchaImg" />
          </div>

          <div @click="login"   class="login-btn">登 录</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import HeaderWeather from "@/components/HeaderWeather/HeaderWeather.vue";
  import HeaderAbout from "@/components/HeaderAbout/HeaderAbout.vue";
  import HeaderTime from "@/components/HeaderTime/HeaderTime.vue";
  import { getCodeImage } from '@/api/login';

  export default {
    name: 'Login',
    components: {
      HeaderTime,
      HeaderAbout,
      HeaderWeather
    },
    mounted() {
      this.getCodeImg();
    },
    data() {
      return {
        username:"",
        password:"",
        captcha:"",
        captchaImg:"",
        uuid:"",
        loginLoading:false
      }
    },
    methods: {
      clearForm(){
        this.username = "";
        this.password = "";
        this.captcha = "";
        this.uuid = "";
      },
      //获取验证码
      getCodeImg(){
        getCodeImage().then(res=>{
            this.uuid = res.data.uuid;
            this.captchaImg = res.data.img;
        })
      },
      //登录
      login(){
        if(!this.username){
          this.$message.warning("请输入用户名 ！");
          return;
        }
        if(!this.password){
          this.$message.warning("请输入密码！");
          return;
        }
        if(!this.captcha){
          this.$message.warning("请输入验证码！");
          return;
        }
        this.loginLoading = true;
        let formatPass = this.$md5(this.password);
        let loginBody = {
            username:this.username,
            password:formatPass,
            code: this.captcha,
            uuid:this.uuid
        }
        let that = this;
        this.$store.dispatch("Login", loginBody).then(() => {
          that.clearForm();
          this.$router.push({ path: this.redirect || "/" }).catch(()=>{});
        }).catch((e) => {
          console.log(e)
          this.getCodeImg();
        });
      }
    }
  }
</script>

<style lang="scss">
.login-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -500px;
  margin-top: -350px;
}

.login-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 800px;
  height: 650px;
  margin-left: -400px;
  margin-top: -300px;
  box-sizing: border-box;
}

.login-row {
  width: 600px;
  height: 80px;
  box-shadow: inset 0 0 10px #fff;
  margin-bottom: 40px;
  box-sizing: border-box;
  padding: 0 30px;
  display: flex;
  align-items: center;
  .row-icon {
    width: 40px;
    height: 40px;
  }
  .row-input {
    flex: 1;
    margin-left: 20px;
    font-size: 28px;
    color: #fff;
  }
  .row-code {
    width: 170px;
    height: 80px;
    cursor: pointer;
  }
}

.login-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  height: 80px;
  background: #1b457f;
  color: #fff;
  font-size: 40px;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: -30px;
  margin-top: 20px;
}

.login-box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid white;
  border-radius: 30px;
}

.login-title{
  width: 100%;
  text-align: center;
  font-size: 34px;
  padding-bottom: 40px;
  color: #f0f9ff;
  letter-spacing: 5px;
}
</style>


